var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-content',[_c('Menu'),_vm._t("default")],2),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }